import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 38vw;
	max-width: 550px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;
`;

export const datasBox = styled.div`
	width: 100%;
	max-height: 200px;
	overflow: auto;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: space-between;
`;

export const itemList = styled.div`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 1fr 4rem;
	gap: 0.5rem;
	align-items: center;
	justify-content: space-between;

	> svg {
		cursor: pointer;
		transform: translateY(35%);
		font-size: 3rem;
		color: ${color.interface.lightGray};
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: fit-content;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	padding: 1.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;

	> p {
		color: ${color.interface.lightGray};
		font-size: 1.5rem;
	}
`;
